import { Inject } from './decorators';

/**
 * @class BaseComponent
 * Base component for angular components which support @Inlect and @Async decorator.
 * Use full to use it instead of ordinary components as it have loading mechanism,
 * setup components data hooks and more.
 * */
export default class BaseComponent {
    @Inject('Logger') logger;
    @Inject('$scope') $scope;

    constructor(...args) {
        [...(args || [])].forEach((value, index) => {
            this[this.constructor.injectableProperties[index]] = value;
        });
    }

    loading = false;

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }

    async $onInit() {
        this.startLoading();

        try {
            await this.componentDataWillSetup();
            await this.setupComponentData();
            await this.componentDataDidSetup();
        } catch (error) {
            this.logger.error(error);
        } finally {
            this.stopLoading();
            this.applyScope();
        }
    }

    componentDataWillSetup() {}

    setupComponentData() {}

    componentDataDidSetup() {}

    applyScope() {
        this.$scope.$apply();
    }
}